/**
 * Repite una operación que puede fallar por causas pasajeras: la red, un servicio que tarda en
 * responder la primera vez, el token de invitado que todavía no llega.
 *
 * Espera un poco más antes de cada nuevo intento (1 s, 2 s, 3 s... con la espera por defecto) y,
 * si todos fallan, lanza el último error para que quien llama decida qué mostrar.
 */
export const reintentar = async <T>(
  operacion: () => Promise<T>,
  {
    intentos = 3,
    espera = 1000,
    seguir = () => true,
  }: {
    intentos?: number;
    /** Milisegundos base entre intentos; se multiplica por el número del intento */
    espera?: number;
    /** Permite cortar los reintentos, por ejemplo si el formulario ya se cerró */
    seguir?: () => boolean;
  } = {}
): Promise<T> => {
  let ultimoError: unknown;

  for (let intento = 1; intento <= intentos; intento++) {
    try {
      return await operacion();
    } catch (error) {
      ultimoError = error;
      if (intento === intentos || !seguir()) break;
      await new Promise((resolver) => setTimeout(resolver, espera * intento));
      // Se vuelve a preguntar: durante la espera el formulario pudo cerrarse
      if (!seguir()) break;
    }
  }

  throw ultimoError;
};
